import React, { useState, useEffect } from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import { getRecords, saveRecords } from '../../services/api.service';
import { toast } from 'react-toastify';
import { fetchVendorActionLogDetails } from '../../custom/Utils/vendorLogsUtils';

export default function PoHeadersView() {
    const navigate = useNavigate();
    let { id } = useParams();
    const [poData, setPoData] = useState([]);
    const [poLogData, setPoLogData] = useState([]);
    const [poLinesData, setPoLinesData] = useState([]);
    const [buyerGroup, setBuyerGroup] = useState([]);
    const [loadingData, setLoadingData] = useState(!!id);

    useEffect(() => {
        if (id) {
            getData(id);
            getPoLogData(id);
            getPoLinesData(id);
        }
    }, [id]);

    const getData = async (id) => {
        try {
            let payload = {
                modelName: 'po_managements',
                whereCondition: {
                    id: id,
                },
                relations: [
                    {
                        module: 'warehouse_masters',
                        moduleAs: 'warehouse_masters',
                    },
                    {
                        module: 'vendor_masters',
                        moduleAs: 'vendor_masters',
                    },
                    {
                        module: 'po_status',
                        moduleAs: 'po_status',
                    },
                ],
            };
            const responseData = await getRecords(
                '/common/getRecords',
                payload
            );
            if (responseData.data && responseData.data.length > 0) {
                const data = responseData.data[0];
                setPoData(data);
                await fetchVendorActionLogDetails(
                    `View - PO Information - ${data.po_number_72}`
                );
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoadingData(false);
        }
    };

    const getPoLogData = async (id) => {
        try {
            let payload = {
                modelName: 'po_logs',
                whereCondition: {
                    po_id_149: id,
                },
                relations: [
                    {
                        module: 'po_status',
                        moduleAs: 'po_status',
                    },
                ],
            };
            const responseData = await getRecords(
                '/common/getRecords',
                payload
            );
            if (responseData.data && responseData.data.length > 0) {
                const data = responseData.data;
                setPoLogData(data);
                console.log('data for Po Logs===>', data);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoadingData(false);
        }
    };

    const getPoLinesData = async (id) => {
        try {
            let payload = {
                modelName: 'po_details',
                whereCondition: {
                    po_id_126: id,
                },
                relations: [
                    {
                        module: 'vendor_item_masters',
                        moduleAs: 'vendor_item_masters',
                    },
                ],
            };
            const responseData = await getRecords(
                '/common/getRecords',
                payload
            );
            if (responseData.data && responseData.data.length > 0) {
                const data = responseData.data;
                setPoLinesData(data);
                console.log('data for Po Lines===>', data);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoadingData(false);
        }
    };


   const formatDate = (dateString) => {
       // Regex to check if the date is already in DD-MM-YYYY format
       const dateFormatRegex = /^\d{2}-\d{2}-\d{4}$/;

       if (dateFormatRegex.test(dateString)) {
           return dateString; // Return the date as is if it's already formatted
       }

       const date = new Date(dateString);

       if (isNaN(date.getTime())) {
           return '-'; // Return '-' for invalid dates
       }

       const day = String(date.getDate()).padStart(2, '0');
       const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
       const year = date.getFullYear();

       return `${day}-${month}-${year}`;
   };
const formatLogDate = (dateString) => {
    const date = new Date(dateString);

    // Format date components
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();

    // Format time components
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert to 12-hour format

    return `${day}-${month}-${year} ${String(hours).padStart(
        2,
        '0'
    )}:${minutes} ${ampm}`;
};
    return (
        <div className='page-content'>
            <Container fluid>
                <div className='tabs-animation'>
                    <Card>
                        <CardBody>
                            <div className='d-flex justify-content-between align-items-center'>
                                <h3>View PO Information</h3>
                                <button
                                    className='btn btn-primary'
                                    onClick={(e) =>
                                        navigate('/po-headers-list')
                                    }
                                >
                                    Back
                                </button>
                            </div>

                            {/* PO Headers Table with Legend */}
                            <fieldset
                                style={{
                                    border: '1px solid #ddd',
                                    padding: '15px',
                                    marginBottom: '20px',
                                    marginTop: '10px',
                                }}
                            >
                                <legend
                                    style={{
                                        fontSize: '1.5rem',
                                        color: '#000',
                                    }}
                                >
                                    PO Headers
                                </legend>
                                <div className='row'>
                                    <div className='col'>
                                        <table className='table table-striped table-bordered'>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            PO Number
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.po_number_72 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            PO Date
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.po_date_73
                                                            ? formatDate(
                                                                  poData.po_date_73
                                                              )
                                                            : 'Not Set'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Vendor Code
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.vendor_masters
                                                            ?.vendor_code_44 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Vendor Name
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.vendor_name_76 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Site
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.site_78 || 'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Warehouse
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData
                                                            ?.warehouse_masters
                                                            ?.warehouse_name_21 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Location
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.location_80 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Buyer Group
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.buyer_group_81 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            PO Owner
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.po_owner_82 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className='col'>
                                        <table className='table table-striped table-bordered'>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            PO Indentor
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.po_indentor_83 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Indentor Mobile
                                                            Number
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.indentor_mobile_no_84 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            TDS Applicable
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.tds_applicable_85 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            TDS Group
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.tds_group_86 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Mode of Delivery
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.mode_of_delivery_88 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Payment Terms
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.payment_terms_89 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Method of Payment
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.method_of_payment_90 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Cost Center
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.cost_center_91 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Department
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.department_92 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Project
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.project_93 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className='col'>
                                        <table className='table table-striped table-bordered'>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Delivery Date
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData?.delivery_date_87
                                                            ? formatDate(
                                                                  poData.delivery_date_87
                                                              )
                                                            : 'Not Set'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Min. GRN Date
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData?.minimum_grn_date_94
                                                            ? formatDate(
                                                                  poData?.minimum_grn_date_94
                                                              )
                                                            : 'Not Set'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Committed Date 1
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData?.delivery_date_1_95
                                                            ? formatDate(
                                                                  poData?.delivery_date_1_95
                                                              )
                                                            : 'Not Set'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Committed Date 2
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData?.delivery_date_2_96
                                                            ? formatDate(
                                                                  poData?.delivery_date_2_96
                                                              )
                                                            : 'Not Set'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            VP Status
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData?.po_status
                                                            ?.name || 'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            ERP Status
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData?.po_status_microsoft_130 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <strong className='table-header-bold-extra'>
                                                            Remark
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {poData.remark_132 ||
                                                            'NA'}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset
                                style={{
                                    border: '1px solid #ddd',
                                    padding: '15px',
                                    marginBottom: '20px',
                                    marginTop: '10px',
                                }}
                            >
                                <legend
                                    style={{
                                        fontSize: '1.5rem',
                                        color: '#000',
                                    }}
                                >
                                    PO Lines
                                </legend>
                                <div className='table-responsive'>
                                    <table className='table table-bordered'>
                                        <thead>
                                            <tr>
                                                <th className='table-header-bold-extra'>
                                                    #
                                                </th>
                                                <th className='table-header-bold-extra'>
                                                    Item Code
                                                </th>
                                                <th className='table-header-bold-extra'>
                                                    Item Name
                                                </th>
                                                <th className='table-header-bold-extra'>
                                                    Unit
                                                </th>
                                                <th className='table-header-bold-extra'>
                                                    Quantity
                                                </th>
                                                <th className='table-header-bold-extra'>
                                                    Price
                                                </th>
                                                <th className='table-header-bold-extra'>
                                                    Other Charges
                                                </th>
                                                <th className='table-header-bold-extra'>
                                                    Assessable Value
                                                </th>
                                                <th className='table-header-bold-extra'>
                                                    Net Amount
                                                </th>
                                                <th className='table-header-bold-extra'>
                                                    HSN
                                                </th>
                                                <th className='table-header-bold-extra'>
                                                    SAC
                                                </th>
                                                <th className='table-header-bold-extra'>
                                                    PO Line Status
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {poLinesData &&
                                            poLinesData.length > 0 ? (
                                                poLinesData.map(
                                                    (log, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>
                                                                {log.item_code_113 ||
                                                                    '-'}
                                                            </td>
                                                            <td>
                                                                {log
                                                                    .vendor_item_masters
                                                                    ?.item_name_39 ||
                                                                    '-'}
                                                            </td>
                                                            <td>
                                                                {log
                                                                    .vendor_item_masters
                                                                    ?.unit_41 ||
                                                                    '-'}
                                                            </td>
                                                            <td>
                                                                {log.quantity_115 ||
                                                                    '-'}
                                                            </td>
                                                            <td>
                                                                {log.price_116 ||
                                                                    '-'}
                                                            </td>
                                                            <td>
                                                                {log.other_charges_117 ||
                                                                    '-'}
                                                            </td>
                                                            <td>
                                                                {log.assessable_value_119 ||
                                                                    '-'}
                                                            </td>
                                                            <td>
                                                                {log.net_amount_118 ||
                                                                    '-'}
                                                            </td>
                                                            <td>
                                                                {log.hsn_120 ||
                                                                    '-'}
                                                            </td>
                                                            <td>
                                                                {log.sac_121 ||
                                                                    '-'}
                                                            </td>
                                                            <td>
                                                                {log.po_line_status_156 ||
                                                                    '-'}
                                                            </td>
                                                        </tr>
                                                    )
                                                )
                                            ) : (
                                                <tr>
                                                    <td
                                                        colSpan='12'
                                                        className='text-center'
                                                    >
                                                        No data available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </fieldset>

                            {/* PO Log Section with Legend */}
                            <fieldset
                                style={{
                                    border: '1px solid #ddd',
                                    padding: '15px',
                                    marginBottom: '20px',
                                    marginTop: '10px',
                                }}
                                className='mt-4'
                            >
                                <legend
                                    style={{
                                        fontSize: '1.5rem',
                                        color: '#000',
                                    }}
                                >
                                    PO Log
                                </legend>
                                <div className='table-responsive'>
                                    <table className='table table-bordered'>
                                        <thead>
                                            <tr>
                                                <th className='table-header-bold-extra'>
                                                    #
                                                </th>
                                                <th className='table-header-bold-extra'>
                                                    Updated By
                                                </th>
                                                <th className='table-header-bold-extra'>
                                                    Type
                                                </th>
                                                <th className='table-header-bold-extra'>
                                                    VP Status
                                                </th>
                                                <th className='table-header-bold-extra'>
                                                    Remark
                                                </th>
                                                <th className='table-header-bold-extra'>
                                                    Date
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {poLogData &&
                                            poLogData.length > 0 ? (
                                                poLogData.map((log, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            {log.type_151 === 1
                                                                ? log
                                                                      .user_master
                                                                      ?.employee_master
                                                                    ? `${
                                                                          log
                                                                              .user_master
                                                                              .employee_master
                                                                              .first_name
                                                                      } ${
                                                                          log
                                                                              .user_master
                                                                              .employee_master
                                                                              .middle_name ||
                                                                          ''
                                                                      } ${
                                                                          log
                                                                              .user_master
                                                                              .employee_master
                                                                              .last_name
                                                                      }`
                                                                    : '-'
                                                                : log.type_151 ===
                                                                  2
                                                                ? log
                                                                      .vendor_user
                                                                      ?.name_66 ||
                                                                  '-'
                                                                : '-'}
                                                        </td>
                                                        <td>
                                                            {log.type_151 === 1
                                                                ? 'GMMPL'
                                                                : log.type_151 ===
                                                                  2
                                                                ? 'Vendor'
                                                                : '-'}
                                                        </td>
                                                        <td>
                                                            {log.po_status
                                                                ?.name || '-'}
                                                        </td>
                                                        <td>
                                                            {log.remark_150 ||
                                                                '-'}
                                                        </td>
                                                        <td>
                                                            {log.date_155
                                                                ? formatLogDate(
                                                                      log.date_155
                                                                  )
                                                                : '-'}
                                                        </td>{' '}
                                                        {/* Format date if needed */}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td
                                                        colSpan='6'
                                                        className='text-center'
                                                    >
                                                        No data available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </fieldset>
                        </CardBody>
                    </Card>
                </div>
            </Container>
        </div>
    );
}
